import React from 'react';
import styled from 'styled-components';
import { InnerLayout } from '../../styles/Layouts';
import { Title } from '../Ui/Title';
import { skillsSummary } from '../../data/skillsSummary';
import { SkillSummaryCard } from './SkillSummaryCard';

export const SkillsSummarySection = () => {
  return (
    <InnerLayout>
      <SkillsSummarySectionStyled>
        <Title title={'Skills summary'} span={'Skills summary'} />
        <div className='services'>
          {skillsSummary.map(skill => (
            <SkillSummaryCard
              key={skill.id}
              image={skill.image}
              title={skill.title}
              paragraph={skill.paragraph}
            />
          ))}
        </div>
      </SkillsSummarySectionStyled>
    </InnerLayout>
  );
};

const SkillsSummarySectionStyled = styled.section`
  .services {
    margin-top: 5rem;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 1.5rem;
    @media screen and (max-width: 1000px) {
      flex-direction: column;
    }
    @media screen and (max-width: 950px) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media screen and (max-width: 650px) {
      grid-template-columns: repeat(1, 1fr);
    }
  }
`;
